import { required, email } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'

const validationsAgent = {
  form: {
    name: {
      required
    },
    reference_id: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required
    },
    country: {
      required
    }
  }
}

let agentsMethods = {
  checkForm () {
    let valid = !this.$v.$invalid
    if (!valid) {
      this.$v.$touch()
    } else {
      this.$v.$reset()
    }
    return valid
  },
  ...mapActions(
    'util',
    [
      'getCountries'
    ]
  )
}

let agentsComputed = {
  ...mapGetters(
    'util',
    [
      'countries',
      'select2Countries'
    ]
  )
}

const commonAgent = {
  methods: {
    ...agentsMethods
  },
  computed: {
    ...agentsComputed
  },
  created () {
    if (!this.countries) {
      this.getCountries()
    }
  }
}

export { commonAgent, validationsAgent }



// WEBPACK FOOTER //
// ./src/views/agents/mixins.js